// extracted by mini-css-extract-plugin
export default {"preTitle":"vehicleItem_preTitle__xk1Zs","lineButtons":"vehicleItem_lineButtons__mjVsq","twoInLine":"vehicleItem_twoInLine__ijTAv"};